<template>
  <div class="first-course">
    <div class="course-content">
      <div v-for="(item, index) in courseData.subCourses" :key="index" :style="item.modelType === 3 ? 'display:inline-block; vertical-align: top;' : ''">
        <div class="banner-course" v-if="item.modelType == 1" @click="onclick(item, index)">
          <div class="course-item">
            <img :src="item.imageUrl" />
            <p class="first-title text-overflow">{{ item.title }}</p>
            <p class="second-title text-overflow">{{ item.subTitle }}</p>
          </div>
        </div>

        <div class="small-course" v-if="item.modelType == 2" @click="onclick(item, index)">
          <div class="course-item">
            <img :src="item.imageUrl" />
            <div class="item-content">
              <p class="first-title text-overflow">{{ item.title }}</p>
              <p class="second-title text-overflow">{{ item.subTitle }}</p>
            </div>
          </div>
        </div>
        
        <div class="large-course" v-if="item.modelType == 3" @click="onclick(item, index)">
          <div class="course-item">
            <img :src="item.imageUrl" />
            <p class="first-title text-overflow">{{ item.title }}</p>
            <p class="second-title text-overflow">{{ item.subTitle }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["courseData", "onclick"],
  data() {
    return {};
  },

  watch: {
    courseData(n, o) {
      this.courseData = n;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@style/main.scss";

.first-course {
  .course-cover {
    margin-bottom: rem(40);
    img {
      width: 100%;
      height: rem(426);
    }

    .first-title {
      font-size: rem(30);
      line-height: rem(72);
      color: #333;
      padding: 0 rem(30);
      font-weight: bold;
    }
    .second-title {
      padding: 0 rem(30);
      font-size: rem(22);
      color: rgba($color: #333, $alpha: 0.5);
    }
  }
}

.banner-course {
  .course-item {
    margin-bottom: rem(40);

    img {
      width: 100%;
      height: rem(426);
    }

    .first-title {
      font-size: rem(30);
      line-height: rem(72);
      color: #333;
      padding: 0 rem(30);
      font-weight: bold;
      word-break: break-word;
    }

    .second-title {
      padding: 0 rem(30);
      font-size: rem(22);
      color: rgba($color: #333, $alpha: 0.5);
      word-break: break-word;
    }
  }
}

.small-course {
  padding: 0 rem(30);
  .course-item {
    margin-bottom: rem(40);
    display: flex;
    flex-direction: row;
    align-items: center;
    img {
      width: rem(174);
      height: rem(174);
      border-radius: rem(10);
    }
    .item-content {
      width: rem(500);
      margin-left: rem(20);
      .first-title {
        font-size: rem(30);
        color: #333;
        font-weight: bold;
        word-break: break-word;
        line-height: rem(35);
      }

      .second-title {
        margin-top: rem(20);
        font-size: rem(22);
        color: rgba($color: #333, $alpha: 0.5);
        word-break: break-word;
        line-height: rem(30);
      }
    }
  }
}

.large-course {
  width: rem(335);
  min-height: rem(400);
  padding-left: rem(30);
  display: inline-block;

  .course-item {
    width: 100%;
    margin-bottom: rem(40);

    img {
      width: 100%;
      height: rem(335);
      border-radius: 12px;
    }

    .first-title {
      font-size: rem(30);
      line-height: rem(42);
      color: #333;
      font-weight: bold;
      word-break: break-word;
    }

    .second-title {
      line-height: rem(30);
      font-size: rem(22);
      color: rgba($color: #333, $alpha: 0.5);
      word-break: break-word;
    }
  }
}

.text-overflow {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>